import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { useLocation } from 'react-router-dom';
import {
    useGetSupplierGroupByNameQuery,
    useGetGroupOnlySupplierGroupsQuery,
    useGetPaymentandTermsQuery,
    useUpdateSupplierGroupMutation

} from '../../../../store/api/supplier';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Tab2 from './Tab2';
import Attachment from '../../../../utils/Attachment';
import { usePageState } from "../../../../Hook/usePageState";
import { isStateChanged } from "../../../../utils/stateComparator";
function Supplier() {
    const location = useLocation()
    const suppliername = location.state.supplier

    const navigate = useNavigate()
    const [res, setRes] = useState(false)
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [selectedCompanyAccounts, setSelectedCompanyAccounts] = useState([]);

    const [company, setCompany] = useState([])
    const [initialData, setInitialData] = useState([]);
    const [payment, setpayment] = useState([])
    const [supplier, setsupplier] = useState([])
    const [updateSupplierGroup] = useUpdateSupplierGroupMutation();
    const { data, error: supplierError, isLoading } = useGetSupplierGroupByNameQuery(suppliername, {
        skip: !suppliername,
    });

    const { data: supplierData, isEror, issLoading } = useGetGroupOnlySupplierGroupsQuery()

    const { data: paymentata, ispError, ispLoading } = useGetPaymentandTermsQuery()

const pageStateDefault = {
         tab: 1,
         supplirGrpname: "",
         selectedSupplier: "",
         selectedpayment:'',
         isGroup:false,
         accounts:[{  company: "",
        account: ""}],
     
       };
     
       const [pageState, setPageState] = usePageState(`Edit Supplier Group - ${suppliername}`, pageStateDefault);
     
     
       const { tab, supplirGrpname, selectedSupplier, selectedpayment, isGroup,accounts } = pageState;
    useEffect(() => {
        if (supplierData) {
            setsupplier(supplierData.data);
        }
    }, [supplierData]);

    useEffect(() => {
        if (paymentata) {
            setpayment(paymentata.data)
        }
    }, [paymentata])


   
    const handleSubmit = async () => {
        const payload = {
            parent_supplier_group: selectedSupplier,
            payment_terms: selectedpayment ? selectedpayment : '',
            is_group: isGroup,
            accounts: accounts
        };
        try {
            const response = await updateSupplierGroup({
                name: suppliername,
                payload: payload
            });
            setError('Supplier Group Updated successfully!');
            setptype('Success');
            setShowError(true);
            setTimeout(() => {
                navigate('/master/suppliergroup/supplier-list');
            }, 2000);
        } catch (err) {
            const parsedMessages = JSON.parse(error.data._server_messages); //
            const firstMessageObj = JSON.parse(parsedMessages[0]);
            console.log(firstMessageObj, "errr");
            setError(firstMessageObj.message);
            setShowError(true);
            console.error('Update failed:', err);
        }
    }


    useEffect(() => {

         if (!isStateChanged(pageState, pageStateDefault)) {
        if (supplierError) {
            setError('Failed to fetch supplier group');
            setptype("Error");
            setShowError(true);
        } else if (data) {
            console.log(data.data.name, "fulds");
            // setSelectedSupplier(data.data.parent_supplier_group);
            // setSuppliergrpname(data.data.name);
            // setIsGroup(data.data.is_group);
            // setSelectedpayment(data.data.payment_terms);
            // const accounts = data.data.accounts || [];
            // setSelectedCompanyAccounts(accounts);
            // setInitialData(accounts.map(item => ({
            //     company: item.company,
            //     account: item.account
            // })));
            setPageState({
              ...pageState,
              supplirGrpname: data.data.name,
              selectedSupplier: data.data.parent_supplier_group,
              selectedpayment: data.data.payment_terms,
              isGroup: data.data.is_group,
              accounts: data.data.accounts,


            });
        }
    }
    }, [data, supplierError, setSelectedCompanyAccounts]);




    return (
        <>
            <FormLayoutTwo
                title="Edit Supplier Group"
                breadcrumbs={[
                    { label: "Supplier Group" },
                    { label: "Supplier Group List", url: "/master/suppliergroup/supplier-list" }
                ]}
                status={'hide'}
                actionButtons={
                    <>
                        <Button
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            onClick={handleSubmit}

                            iconSize={12}
                        // display={finalstep ? 'none' : 'flex'}
                        >
                            {/* {po_response.result ? 'Submit' : 'Save'} */}update
                        </Button>
                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { setPageState({ ...pageState, tab: 1 }) }} href="javascript:void(0);">
                                        General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                              <Attachment doctype="Supplier Group"  docname={suppliername}  />    
                        </div>
                    </div>

                       <div className=" " style={{ background: '' }}>
                        <div className="row">
                            <div className="col-12">
                                <div className="sidebarbox m-0">
                                    <Tab1  
                                    
                                                                       selectedSupplier = {{
                                                          supplier: supplier,
                                                          value: pageState.selectedSupplier,
                                                          setValue: (val) => setPageState({ ...pageState, selectedSupplier: val }),
                                                          
                                                        }}
                                                                        supplirGrpname={{
                                                          value: pageState.supplirGrpname,
                                                          setValue: (val) => setPageState({ ...pageState, supplirGrpname: val }),
                                                          
                                                        }}
                                     selectedpayment = {{
                                                          payment: payment,
                                                          value: pageState.selectedpayment,
                                                          setValue: (val) => setPageState({ ...pageState, selectedpayment: val }),
                                                        }}
                                                        isGroup={{
                                                          value: pageState.isGroup,
                                                          setValue: (val) => setPageState({ ...pageState, isGroup: val }),
                                                          
                                                        }}
                                    
                                                                                                                 
                                                                                                                 
                                                                                      handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                                                                        onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                                                                                          
                                                                                        />
                                                                       {/* <Tab1 supplier={supplier}
                                                        setsupplier={setsupplier}
                                                        setSelectedSupplier={setSelectedSupplier}
                                                        selectedSupplier={selectedSupplier}
                                                        supplirGrpname={supplirGrpname}
                                                        setSuppliergrpname={setSuppliergrpname}
                                                        payment={payment}
                                                        selectedpayment={selectedpayment}
                                                        setIsGroup={setIsGroup}
                                                        isGroup={isGroup}
                                                        setSelectedpayment={setSelectedpayment}
                                                      /> */}
                                                      <Tab2
                                                       pageState={pageState}
                                                                                                                        setPageState={setPageState}
                                                                                      handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                                                                        onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                                                                        accounts={{
                                      value: pageState.accounts || [],
                                      setValue: (val) => setPageState({
                                        ...pageState,
                                        accounts: val,
                                      }),
                                    }}
                                             suppliername={suppliername}                                                             
                                                        // setSelectedCompanyAccounts={setSelectedCompanyAccounts}
                                                      />
                                  {/* <Tab1
                                        supplier={supplier}
                                        setsupplier={setsupplier}
                                        setSelectedSupplier={setSelectedSupplier}
                                        selectedSupplier={selectedSupplier}
                                        supplirGrpname={supplirGrpname}
                                        setSuppliergrpname={setSuppliergrpname}
                                        selectedpayment={selectedpayment}
                                        setIsGroup={setIsGroup}
                                        isGroup={isGroup}
                                        setSelectedpayment={setSelectedpayment}
                                        payment={payment}
                                    />
                                    <Tab2
                                        setSelectedCompanyAccounts={setSelectedCompanyAccounts}
                                        initialData={initialData} suppliername={suppliername}
                                    /> */}
                                </div>
								
                                
                            </div>
                        </div>
                    </div>


             
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayoutTwo>
        </>
    )
}

export default Supplier
